<template>
   <div id="nosotros">

      <div class="banner1">
         <div class="fondo"></div>
         <div class="dvContenido">
            <div class="title">
               Sobre Nosotros
            </div>
            <div class="contenido">
               En SekaiSoft, el enfoque está siempre en nuestros clientes. Somos un equipo experto que quiere crear compañías increíbles, por eso somos una extensión directa de su marca.
            </div>
         </div>
      </div>

      <div class="banner2">
         <div class="fondo"></div>
         <div class="dvContenido">
            <div class="title">
               Misión
            </div>
            <div class="contenido">
               Ser una de las primeras opciones a nivel internacional en brindar soluciones tecnológicas de calidad que se adapten a las necesidades y presupuesto de nuestros clientes  bridando siempre la calidad  y pasión que SekaiSoft tiene en la realización de cada uno de  los proyectos que realiza.
            </div>
         </div>
      </div>

      <div class="banner1">
         <div class="fondo"></div>
         <div class="dvContenido">
            <div class="title">
               OBJETIVO GENERAL
            </div>
            <div class="contenido">
               Desarrollar software de calidad, capaz de brindar una  oportunidad de crecimiento a nuestros clientes  que requieran de  nuestros servicios.
            </div>
         </div>
      </div>


     <div class="banner2">
       <div class="fondo"></div>
       <div class="dvContenido">
         <div class="title">
           ¿Quienes somos?
         </div>
         <div class="contenido">
           Somos profesionales orientados a los resultados que se levantan todos los días con un objetivo en mente: ayudarlo a construir la mejor marca del mundo. Cuando se trata de hacer crecer su empresa, ningún trabajo es demasiado pequeño para nosotros, ni ningún desafío es demasiado grande para nosotros.
         </div>
       </div>
     </div>

     <div class="banner1">
       <div class="fondo"></div>
       <div class="dvContenido">
         <div class="title">
           No solo escribimos valores.<br />Vivimos por ellos.
         </div>
         <div class="contenido">
           Deseamos crear experiencias de productos que muevan a las personas, resuelvan problemas para nuestros clientes y, en última instancia, creen un valor medible para los clientes a los que sirven.
         </div>
       </div>
     </div>

     <div class="equipo" v-if="false">
       <div class="scene">
         <div class="cube is-backface-hidden" :class="'show-' + selected">
           <div class="cube__face cube__face--front" @click="rotar('right')">
             <span class="puesto">Diseñadora UX/UI</span>
             <img src="../assets/equipo/Yosi.png"/>
           </div>
           <div class="cube__face cube__face--right" @click="rotar('front')">
             Me satisface crear algo de utilidad y que, al mismo tiempo, aporte belleza al entorno. Soy una apasionada de lo que me gusta, valoro positivamente la capacidad de trabajo en equipo y la armonía que existe entre nosotros.
           </div>
         </div>
       </div>

       <div class="scene">
         <div class="cube is-backface-hidden" :class="'show-' + selected">
           <div class="cube__face cube__face--front" @click="rotar('right')">
             <span class="puesto">Desarrolladora Sr</span>
             <img src="../assets/equipo/Yosi.png"/>
           </div>
           <div class="cube__face cube__face--right" @click="rotar('front')">
             Experta en desarrollo de software, especialmente en aplicaciones web a la medida.
             Gran experiencia en análisis y desarrollo de soluciones de TI para multitud de clientes de diferentes sectores
           </div>
         </div>
       </div>


       <div class="scene" >
         <div class="cube is-backface-hidden" :class="'show-' + selected">
           <div class="cube__face cube__face--front" @click="rotar('right')">
             <span class="puesto">Desarrolladora Sr</span>
             <img src="../assets/equipo/Yosi.png"/>
           </div>
           <div class="cube__face cube__face--right" @click="rotar('front')">
             Cuento con gran experiencia como un profesional TI con pericia en diseño, arquitectura, desarrollo, implementación, soporte, evaluación, integración y análisis de procesos de negocio y entrenamiento de usuario final.
           </div>
         </div>
       </div>

     </div>


   </div>
</template>

<script>
  import {mapActions, mapMutations, mapState} from 'vuex'
  import Contactanos from "../components/Contactanos";

   export default {
      name: "Nosotros",
       components: {Contactanos},
     created: function () {
        setTimeout( () => {
          this.changeMenu({logo: '', value: 'Nosotros', ruta: 'Nosotros'});
        }, 200);

       try{
         document.documentElement.scrollTop = 0;
       }catch (e) {
         document.scrollingElement.scrollTop = 0;
       }

     },

     methods: {
       ...mapMutations([
         'select_menu',
       ]),
       changeMenu: function (item) {
         this.select_menu(item.value);
       },
       rotar: function (item) {
         this.$data.selected = item;
       }
     },
     data: function () {
       return {
         selected: 'front'
       }
     }

   }
</script>

<style scoped lang="scss">
  @import "../style/base";

  #nosotros {
    animation-name: fade;
    animation-duration: 1.5s;
    animation-timing-function: ease-in-out;
    max-width: 1360px;
    margin: 0 auto;
    padding-bottom: 20px;

    & .title {
      width: 80%;
      line-height: 1.2;
      margin-bottom: 6px;
      @include responsiveFont(50, 0.5);
    }

    & .contenido {
      @include fontFormat(24px, 300, #F1F1F1);
      @include responsiveFont(24, 0.6);
    }

    & > div {
      padding: 50px;
      margin-top: 25px;
      &:first-of-type {
        margin: 0;
      }

      &:nth-child(even) {
        & .dvContenido {
          @include flexColumn;
          align-items: flex-end;
        }
      }
      position: relative;
      .fondo {
        position: absolute;
        width: 80%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 1;
        max-width: 890px;
      }

      .dvContenido {
        position: relative;
        z-index: 2;
      }

      &.banner1 {
        //display: none;
        & .title {
          color: #fec303;
        }
        & .contenido {
          width: 70%;
          color: #F1F1F1;
          text-align: justify;
          max-width: 700px;

        }
        & .fondo {
          background: #063e69;
        }

        &:HOVER .fondo{
          box-shadow: 4px 4px 18px 0px #063e69;
        }
      }

      &.banner2 {
        //display: none;
        & .title {
          width: 70%;
          color: #1d1d1d;
          max-width: 700px;
        }

        & .contenido {
          width: 70%;
          color: #1d1d1d;
          text-align: justify;
          max-width: 700px;
        }
        & .fondo {
          background: #fec303;
          left: inherit;
          right: 0;
        }

        &:HOVER .fondo {
          box-shadow: 4px 4px 18px 0px #fec303;
        }
      }
    }


    .equipo {
      @include flexRow;

      .scene {
        width: 300px;
        height: 400px;
        perspective: 600px;
        margin: 20px;

        & .cube {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          transform: translateZ(-150px);
          transition: transform 1s;

          &.cube.show-front  { transform: translateZ(-150px) rotateY(   0deg); }
          &.cube.show-right  { transform: translateZ(-150px) rotateY( -90deg); }


          .cube__face {
            position: absolute;
            @include Montserrat;
            width: 100%;
            height: 100%;
            border: 1px solid #063e69bf;
            font-size: 16px;
            font-weight: bold;
            color: #000000BF;
            text-align: center;
            box-shadow: 6px 6px 12px -4px #444444bf;
            padding: 30px;
            @include flexColumn;
            align-items: center;
            justify-content: center;


            & .puesto {
              color: #ff3464;
              font-size: 20px;
              margin-bottom: 15px;
            }

            & > img {
              width: 150px;
            }

          }

          .cube__face--front  { background: #eaeaea4f; }
          .cube__face--right  { background: #eaeaea4f; }


          .cube__face--front  { transform: rotateY(  0deg) translateZ(150px); }
          .cube__face--right  { transform: rotateY( 90deg) translateZ(150px); }

          &.is-backface-hidden > .cube__face {
            backface-visibility: hidden;
          }

        }

      }
    }


    @include responsive_layout('small') {
      & .title {
        font-size: 40px;
      }

      & .contenido {
        font-size: 18px;
      }

    }



    @media only screen and (max-width: 400px) {
      & .title {
        @include fontFormat(25px, 500, #000000);
      }
    }
  }
</style>
